<div class="registration-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="mg-btm-32">Sign In With:</h2>
    </div>
  </div>

  <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button role="button" class="btn social-fb" (click)="facebookAuth()"></button>
    </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button role="button" class="btn social-google" (click)="googleAuth()"></button>
    </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button role="button" class="btn social-apple" (click)="appleAuth()"></button>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="mg-btm-9 mg-top-12">or Sign In With Email</h2>
    </div>
  </div>

  <app-alert [alertService]="alertService"></app-alert>

  <div class="row mg-top-32">
    <form name="form" (ngSubmit)="onSubmit(signInForm.valid);" [formGroup]="signInForm" novalidate>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group" [ngClass]="{ 'ng-invalid': !signInForm.controls.username.valid }">
          <label for="username">Email Address*</label>
          <input type="text" class="form-control" id="username" name="username" formControlName="username" (input)="onEmailChange($event.target.value)"/>
          <app-validation-message [control]="signInForm.controls.username" class="form-error"></app-validation-message>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group" [ngClass]="{ 'ng-invalid': !signInForm.controls.password.valid }">
          <label for="password">Password*</label>
          <input type="password" class="form-control" id="password" name="password" formControlName="password"/>
          <app-validation-message [control]="signInForm.controls.password" class="form-error"></app-validation-message>
          <span role="button" (click)="showModal('app-forgot-password')" class="forget-sign-link text-right"> Forgot Password? </span>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
        <button type="submit" class="btn wb-btn-default center-block" [disabled]="(loading || disableSignInButton)">
          Sign In
          <span *ngIf="loading" class="loading-animation"></span>
        </button>
      </div>
    </form>
  </div>

  <div class="row">
    <div class="col-md-12 text-center mg-top-18">
      <span (click)="showSignupModal()" role="button" class="forget-sign-link already-link"> Need an account? Join Now</span>
    </div>
  </div>
</div>
